import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiServerService, ApiServiceConfig } from './api-server.service';
import { ElasticSearchService } from './elastic-search.service';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: []
})
export class ApiServerModule {
  constructor(@Optional() @SkipSelf() parentModule?: ApiServerModule) {
    if (parentModule) {
      throw new Error(
        'ApiServerModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(config: ApiServiceConfig): ModuleWithProviders<ApiServerModule> {
    return {
      ngModule: ApiServerModule,
      providers: [
        {provide: ApiServiceConfig, useValue: config },
        ApiServerService,
        ElasticSearchService
      ]
    };
  }
  // static forChild(): ModuleWithProviders<ApiServerModule> {
  //   return {
  //     ngModule: ApiServerModule, providers: [{ provide: ApiServerService, useValue: {} }]
  //   };
  // }
}
